import { jsxs as s, jsx as t } from "react/jsx-runtime";
import { c as d } from "../../clsx-OuTLNxxd.js";
const l = "FareCardFooter-module_footer__FXBG9",
  c = "FareCardFooter-module_content__sqEob",
  m = "FareCardFooter-module_small-padding__u9NPd",
  i = "FareCardFooter-module_cta-button-container__KSI-k",
  _ = "FareCardFooter-module_separator__q2Lqi",
  o = {
    footer: l,
    content: c,
    smallPadding: m,
    ctaButtonContainer: i,
    separator: _
  },
  f = _ref => {
    let {
      children: e,
      ctaButton: a,
      withSeparator: r = !1,
      padding: n = "default"
    } = _ref;
    return /* @__PURE__ */s("footer", {
      className: o.footer,
      children: [r && /* @__PURE__ */t("hr", {
        className: o.separator
      }), /* @__PURE__ */t("div", {
        className: d(o.content, {
          [o.smallPadding]: n == "small"
        }),
        children: e
      }), a && /* @__PURE__ */t("div", {
        className: o.ctaButtonContainer,
        children: a
      })]
    });
  };
export { f as FareCardFooter };